
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reels",
      function () {
        return require("private-next-pages/reels.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reels"])
      });
    }
  